export default __webpack_public_path__ + "static/media/Pricerite.bcf27f15.png";